import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import styles from './DeactivatePromosModal.module.css';

interface DeactivatePromosModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen?: boolean;
  isLoading?: boolean;
}

const DeactivatePromosModal = ({
  onClose,
  onConfirm,
  isOpen = false,
  isLoading = false,
}: DeactivatePromosModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.modal}
      headerContent={<div className={styles.header}>{t('promotions.deactivateModal.header')}</div>}
      showTitleDivider
      footerContent={
        <div className={styles.footer}>
          <Button onClick={onClose} variant={ButtonVariants.Secondary}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} isLoading={isLoading}>
            {t('common.confirm')}
          </Button>
        </div>
      }
      onClose={onClose}
      isOpen={isOpen}
      bodyContent={
        <div className={styles.body}>
          <p>{t('promotions.deactivateModal.text')}</p>
        </div>
      }
    />
  );
};

export default DeactivatePromosModal;
